import { Outlet, useLocation } from "react-router-dom";
import { usePermissions } from "../hooks/usePermissions";
import { getRoutePermission } from "./routePermissions";
import { AccessDeniedPage } from "./AccessDeniedPage";

export function PermissionGuard() {
  const location = useLocation();
  const { can } = usePermissions();

  const requiredPermission = getRoutePermission(location.pathname);

  if (requiredPermission && !can(requiredPermission)) {
    return <AccessDeniedPage />;
  }

  return <Outlet />;
}
